import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    pages: [
      {
        pageName: "home",
        pageId: 1,
        sections: [
          {
            sectionId: "a0us1n",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            fields: [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      {
        // WomenDay2026 campaign
        pageName: "WomenDay2026",
        pageId: 28972,
        isPublic: true,
        sections: [
          {
            sectionId: "orbg8s",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            fields: [
              {
                fieldType: "refresh-token",
                fieldId: "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                fieldType: "key-visual",
                fieldId: "296eg1",
                properties: {
                  grid: {
                    columns: "12"
                  },
                  styles: {
                    margin: "2% 0 0 0",
                    padding: "0"
                  },
                  imageStyles: {
                    "border-radius": "16px"
                  },
                  noContainer: false,
                  addRow: true,
                  desktopImageUrl:
                    "/assets/campaigns/WomenDay2026/key-visual.png",
                  mobileImageUrl: "/assets/campaigns/WomenDay2026/key-visual.png"
                }
              },
              {
                fieldType: "participa",
                fieldId: "acsh315",
                properties: {
                  grid: {
                    columns: "12"
                  },
                  color: "#024491",
                  buttonClass: "btn-dark-red-gradient2",
                  nextPage: "WomenDay2026/InscrieBonul",
                  campaign: "WomenDay2026",
                  borderColor: "#FBDEDF",
                  steps: [
                    {
                      title: "Pasul 1",
                      text: "Cumpara produse Palmolive de min. 30 lei",
                      image: "product"
                    },
                    {
                      title: "Pasul 2",
                      text: "Incarca bonul fiscal",
                      image: "receipt"
                    },
                    {
                      title: "Pasul 3",
                      text: "Inregistreaza-te",
                      image: "register"
                    },
                    {
                      title: "Pasul 4",
                      text: "Castiga premii",
                      image: "reward"
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      {
        // Upload receipt
        pageName: "WomenDay2026/InscrieBonul",
        pageId: 22345,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            sectionId: "fu30zq",
            fields: [
              {
                fieldType: "step-counter",
                fieldId: "tj4j49",
                properties: {
                  activeIndex: 1,
                  colorSchema: "#024491",
                  stepShadow: "#C7DCF5",
                  startGradient: "#C7DCF5",
                  endGradient: "#024491",
                  completedGradient:
                    "linear-gradient(265.49deg, #4D81BD 0.01%, #024491 99.55%), #ffffff",
                  steps: [
                    {
                      title: "Cumpara produse Palmolive",
                      page: "Cumpără Ajax si/sau Axion"
                    },
                    {
                      title: "Incarca bonul fiscal",
                      page: "WomenDay2026/Inregistreaza"
                    },
                    {
                      title: "Inregistreaza-te",
                      page: "WomenDay2026/Inregistreaza"
                    },
                    {
                      title: "Castiga premii",
                      page: "WomenDay2026/Inregistreaza"
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: "dyx8uv",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields:[
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "<h1>Incarca bonul fiscal/factura</h1>",
                  styles: {
                    "font-family": "Plus Jakarta Sans;",
                    color: "#141414"
                  }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "La acest pas, te rugam sa incarci dovada achizitionarii produselor participante Palmolive",
                  grid: {
                    marginTop: "15px",
                    marginBottom: "30px"
                  },
                  styles: {
                    "font-weight": "500;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "20px;",
                    color: "#2E2E2E"
                  }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "basg325",
                properties: {
                  text: "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al bonului fiscal/facturii",
                  grid: {
                    marginBottom: "40px"
                  },
                  styles: {
                    "font-weight": "400;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "14px;",
                    "line-height": "20px;",
                    color: "#474747"
                  }
                }
              }
            ]
          },
          {
            sectionId: "dyx8uv",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "empty-bucket",
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: "center",
                    maxWidth: "1230px"
                  },
                  fields: [
                    {
                      fieldType: "receipt-processor",
                      fieldId: "klvakj",
                      properties: {
                        texts: {
                          choose: "Selecteaza un fisier",
                          receiptUpload:
                            '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat:
                            "Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.",
                          fileSizeLimit:
                            "Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB."
                        },
                        colorSchema: "#024491",
                        fileUploadColor: "rgba(0, 0, 0, 0.5)",
                        borderColor: "#024491",
                        buttonClass: "btn-blue-gradient",
                        grid: {
                          columns: 5,
                          alignItems: "center",
                          justifyContent: "center"
                        },
                        successAction: {
                          fn: "goToPage",
                          params: "WomenDay2026/Inregistreaza"
                        },
                        campaignId: "womenday-ro-2026",
                        phrases: [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        cornerDetectionPhrases: [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        eraseColor: "#ffffff",
                        eraseSize: 12,
                        cropColor: "#F27B26",
                        cropBackground: "rgba(0,0,0,0.6)",
                        cropTitle: "Decupeaza",
                        eraseTitle: "Acopera",
                        dragTitle: "Deplaseaza imaginea",
                        zoomInTitle: "Mareste",
                        zoomOutTitle: "Micsoreaza",
                        selectImageTitle: "Select an Image",
                        selectAnotherTitle: "Select Another",
                        controlsBackground: "#024491",
                        backgroundColorBtn: "black",
                        textColor: "#141414"
                      }
                    },
                    {
                      fieldType: "empty-bucket",
                      properties: {
                        grid: {
                          columns: 7
                        },
                        fields: [
                          {
                            fieldType: "receipt-information",
                            fieldId: "5mq1p6",
                            properties: {
                              grid: {
                                alignItems: "center",
                                justifyContent: "center",
                                columns: "12"
                              },
                              styles: {
                                "text-align": "left"
                              },
                              color: "#024491",
                              textColor: "#141414",
                              descriptionTextColor: "#2E2E2E",
                              descriptionText:
                                "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              receiptImage: "receipt25",
                              steps: [
                                {
                                  text: "Nume Retailer/ Magazin",
                                  label: "A"
                                },
                                {
                                  text: "Produsele care intra in promotie si pretul lor",
                                  label: "B"
                                },
                                {
                                  text: "Suma totala a bonului/facturii in LEI/RON",
                                  label: "C"
                                },
                                {
                                  text: "Nr bonului fiscal/facturii",
                                  label: "D"
                                },
                                {
                                  text: "Data si ora de pe bon sau de pe factura",
                                  label: "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: "bsbsd35",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "receipt-image-information"
              }
            ]
          },
          {
            sectionId: "hmgwhl",
            grid: {
              columns: 12,
              display: "flex",
              alignItems: "center",
              position: "relative",
              paddingTop: "60px",
              paddingBottom: "40px"
            },
            container: true,
            buttonsWrap: true,
            fields: [
              {
                fieldType: "button-component",
                fieldId: "16tzm1",
                properties: {
                  grid: {
                    columns: "0"
                  },
                  addClass: "btn-link",
                  text: "Inapoi",
                  disabled: false,
                  styles: {
                    position: "absolute;",
                    left: 0
                  },
                  action: {
                    fn: "goToPage",
                    params: "WomenDay2026"
                  }
                }
              },
              {
                fieldType: "button-component",
                fieldId: "16tzm2",
                properties: {
                  grid: {
                    columns: "0",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  text: "Continua",
                  addClass: "btn-dark-red-gradient2",
                  shouldCheckCrop: true,
                  requires: ["klvakj"],
                  action: {
                    fn: "sendReceipt",
                    params: ""
                  }
                }
              }
            ]
          }
        ]
      },
      {
        // Register form
        pageName: "WomenDay2026/Inregistreaza",
        pageId: 634553232,
        sections: [
          {
            grid: {
              alignItems: "center",
              justifyContent: "center",
              columns: 12
            },
            fields: [
              {
                fieldType: "step-counter",
                fieldId: "tj4j49",
                properties: {
                  activeIndex: 2,
                  colorSchema: "#024491",
                  stepShadow: "#C7DCF5",
                  startGradient: "#C7DCF5",
                  endGradient: "#024491",
                  completedGradient:
                    "linear-gradient(265.49deg, #4D81BD 0.01%, #024491 99.55%), #ffffff",
                  steps: [
                    {
                      title: "Cumpara produse Palmolive",
                      page: "Cumpără Ajax si/sau Axion"
                    },
                    {
                      title: "Incarca bonul fiscal",
                      page: "WomenDay2026/Inregistreaza"
                    },
                    {
                      title: "Inregistreaza-te",
                      page: "WomenDay2026/Inregistreaza"
                    },
                    {
                      title: "Castiga premii",
                      page: "WomenDay2026/Inregistreaza"
                    }
                  ]
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "fckzg7",
                properties: {
                  text: "<h1 class='text-center'>Formular de inscriere</h1>",
                  styles: {
                    color: "#141414"
                  }
                }
              }
            ]
          },
          {
            sectionId: "ci88zt",
            grid: {
              alignItems: "center",
              justifyContent: "center",
              columns: 4,
              marginTop: "40px"
            },
            container: true,
            fields: [
              {
                fieldType: "form-component",
                fieldId: "j765n4b",
                properties: {
                  styles: {
                    justifyContent: "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#F2F5F9"
                  },
                  grid: {
                    alignItems: "center",
                    columns: "0",
                    justifyContent: "center"
                  },
                  requires: ["1"],
                  successAction: {
                    fn: "goToPage",
                    params: "WomenDay2026/Multumim"
                  },
                  endpoint: "/register",
                  // multiFactorAuth: true,
                  fields: [
                    {
                      fieldId: "b4baqs",
                      fieldType: "text-input",
                      properties: {
                        name: "surname",
                        autocomplete: "no",
                        label: "Prenume",
                        placeholder: "Introdu prenumele",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|onlyLetters",
                        grid: {
                          alignItems: "center",
                          justifyContent: "center",
                          columns: 12
                        },
                        styles: {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "gofije",
                      fieldType: "text-input",
                      properties: {
                        name: "name",
                        autocomplete: "no",
                        label: "Nume",
                        placeholder: "Introdu numele",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|onlyLetters",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "h7kzf9",
                      fieldType: "text-input",
                      properties: {
                        name: "email",
                        label: "E-mail",
                        placeholder: "Introdu e-mailul",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|email",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "vake42c",
                      fieldType: "text-input",
                      properties: {
                        name: "mobile",
                        label: "Numar de telefon",
                        placeholder: "Introdu numarul de telefon",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|phoneNumber",
                        grid: {
                          columns: 12
                        },
                        autocomplete: "nope",
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "ko3h1sz",
                      fieldType: "paragraph",
                      properties: {
                        text: "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        grid: {
                          columns: "12",
                          marginTop: "35px"
                        },
                        classes: ["disclaimer"],
                        styles: {
                          color: "#2E2E2E !important"
                        }
                      }
                    },
                    {
                      fieldType: "google-recaptcha-v2"
                    },
                    {
                      fieldId: "wgc3j7",
                      fieldType: "checkbox",
                      properties: {
                        name: "terms",
                        validation: {
                          required: {
                            allowFalse: false
                          }
                        },
                        validationName: "Termenii si conditiile sunt necesare",
                        grid: {
                          columns: "12",
                          paddingTop: "10px"
                        },
                        styles: {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--checkedCheckbox":
                            "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox":
                            "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        label: `Confirm ca am peste 18 ani. Confirm <a href="/files/WomenDay2026Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: "yh453gg4",
            grid: {
              columns: 12,
              display: "flex",
              alignItems: "center",
              position: "relative",
              paddingTop: "60px",
              paddingBottom: "120px"
            },
            container: true,
            buttonsWrap: true,
            fields: [
              {
                fieldType: "button-component",
                fieldId: "16tzm1",
                properties: {
                  grid: {
                    columns: "0"
                  },
                  addClass: "btn-link",
                  text: "Inapoi",
                  disabled: false,
                  styles: {
                    position: "absolute;",
                    left: 0
                  },
                  action: {
                    fn: "goToPage",
                    params: "WomenDay2026/InscrieBonul"
                  }
                }
              },
              {
                fieldType: "button-component",
                fieldId: "16tzm2",
                properties: {
                  grid: {
                    columns: "0",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  text: "TRIMITE",
                  disabled: false,
                  addClass: "btn-dark-red-gradient2",
                  action: {
                    fn: "sendForm",
                    params: "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      {
        // Thank you
        pageName: "WomenDay2026/Multumim",
        pageId: 99800,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "thank-you",
                fieldId: "gjd10",
                properties: {
                  campaign: "WomenDay2026",
                  campaignName: " Campania Nationala Women's day",
                  haveActivator: false,
                  borderColor: "#27A6DE",
                  textColor: "#141414",
                  referenceColor: "#1A99D1"
                }
              }
            ]
          }
        ]
      },
      {
        // Winner form page with CNP
        pageName: "WomenDay2026/WinnerPageCNP",
        isPublic: true,
        pageId: 634553,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            headerWrap: true,
            sectionId: "basb782",
            fields: [
              {
                fieldType: "query-string-to-state",
                fieldId: "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                fieldType: "query-string-to-state",
                fieldId: "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  grid: {
                    marginTop: "15px",
                    marginBottom: "30px"
                  },
                  styles: {
                    "font-weight": "500;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "20px;",
                    color: "#141414"
                  }
                }
              }
            ]
          },
          {
            sectionId: "ci88zt",
            grid: {
              alignItems: "center",
              justifyContent: "center",
              columns: 4,
              marginTop: "50px"
            },
            container: true,
            fields: [
              {
                fieldType: "form-component",
                fieldId: "j765n4b",
                properties: {
                  styles: {
                    margin: "0",
                    justifyContent: "center",
                    "--backgroundColor": "#F2F5F9"
                  },
                  grid: {
                    alignItems: "center",
                    columns: "0",
                    justifyContent: "center"
                  },
                  requires: ["1"],
                  successAction: {
                    fn: "goToPage",
                    params: "WomenDay2026/WinnerThankYou"
                  },
                  endpoint: "/winnerRegister",
                  fields: [
                    {
                      fieldId: "b4baqs",
                      fieldType: "text-input",
                      properties: {
                        name: "surname",
                        autocomplete: "no",
                        label: "Prenume",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|onlyLetters",
                        grid: {
                          alignItems: "center",
                          justifyContent: "center",
                          columns: 12
                        },
                        styles: {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "gofije",
                      fieldType: "text-input",
                      properties: {
                        name: "name",
                        autocomplete: "no",
                        label: "Nume",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|onlyLetters",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "h7kzf9",
                      fieldType: "text-input",
                      properties: {
                        name: "email",
                        label: "E-mail",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|email",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "vake42c",
                      fieldType: "text-input",
                      properties: {
                        name: "mobile",
                        label: "Numar de telefon",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|phoneNumber",
                        grid: {
                          columns: 12
                        },
                        autocomplete: "nope",
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "h7kzf8",
                      fieldType: "text-input",
                      properties: {
                        name: "address",
                        label: "Adresa",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "requiredAdress|adress",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "ko3h1sz",
                      fieldType: "paragraph",
                      properties: {
                        text: "*strada, numar, bloc, scara, apartament",
                        grid: {
                          columns: "12",
                          marginTop: "20px;",
                          marginBottom: "20px"
                        },
                        classes: ["disclaimer"],
                        styles: {
                          color: "#2E2E2E !important"
                        }
                      }
                    }
                  ],
                  extraFields: [
                    {
                      fieldId: "bdsb632",
                      fieldType: "select-input-county",
                      properties: {
                        name: "judet",
                        label: "Judet",
                        placeholder: "Judet",
                        text: "",
                        color: "#2E2E2E",
                        validation: "requiredJudet",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        },
                        autocomplete: "nope"
                      }
                    },
                    {
                      fieldId: "bask257",
                      fieldType: "select-input-city",
                      properties: {
                        name: "localitate",
                        label: "Localitate",
                        placeholder: "Localitate",
                        text: "",
                        color: "#2E2E2E",
                        validation: "requiredLocal",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        autocomplete: "nope"
                      }
                    },
                    {
                      fieldId: "acasg235",
                      fieldType: "text-input",
                      properties: {
                        name: "postal",
                        label: "Cod postal",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "integer|length:6",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        autocomplete: "nope",
                        disablePaste: true
                      }
                    },
                    {
                      fieldId: "bsdy4362",
                      fieldType: "text-input",
                      properties: {
                        name: "cnp",
                        autocomplete: "no",
                        label: "CNP",
                        placeholder: "",
                        text: "",
                        validation: "required|integer|length:13",
                        color: "#2E2E2E",
                        grid: {
                          alignItems: "center;",
                          justifyContent: "center;",
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "bsadbsd325",
                      fieldType: "checkbox",
                      properties: {
                        name: "cnpConfirm",
                        validation: {
                          required: {
                            allowFalse: false
                          }
                        },
                        validationName: "terms",
                        grid: {
                          columns: "12",
                          paddingTop: "10px"
                        },
                        styles: {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--checkedCheckbox":
                            "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox":
                            "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        label: `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: "yh453gg4",
            grid: {
              columns: 12,
              display: "flex",
              alignItems: "center",
              position: "relative",
              paddingTop: "60px",
              paddingBottom: "130px"
            },
            container: true,
            styles: {
              "justify-content": "center"
            },
            fields: [
              {
                fieldType: "button-component",
                fieldId: "16tzm2",
                properties: {
                  grid: {
                    columns: "0",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  text: "TRIMITE",
                  disabled: false,
                  addClass: "btn-dark-red-gradient2",
                  action: {
                    fn: "sendForm",
                    params: "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      {
        // Winner form page
        pageName: "WomenDay2026/WinnerPage",
        isPublic: true,
        pageId: 634553123,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            headerWrap: true,
            sectionId: "basb782",
            fields: [
              {
                fieldType: "query-string-to-state",
                fieldId: "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                fieldType: "query-string-to-state",
                fieldId: "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "<h1 style=' color= #141414; '>Formular pentru Castigator</h1>"
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  grid: {
                    marginTop: "15px",
                    marginBottom: "30px"
                  },
                  styles: {
                    "font-weight": "500;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "20px;",
                    color: "#141414"
                  }
                }
              }
            ]
          },
          {
            sectionId: "ci88zt",
            grid: {
              alignItems: "center",
              justifyContent: "center",
              columns: 4,
              marginTop: "50px"
            },
            container: true,
            fields: [
              {
                fieldType: "form-component",
                fieldId: "j765n4b",
                properties: {
                  styles: {
                    margin: "0",
                    justifyContent: "center",
                    "--backgroundColor": "#F2F5F9"
                  },
                  grid: {
                    alignItems: "center",
                    columns: "0",
                    justifyContent: "center"
                  },
                  requires: ["1"],
                  successAction: {
                    fn: "goToPage",
                    params: "WomenDay2026/WinnerThankYou"
                  },
                  endpoint: "/winnerRegister",
                  fields: [
                    {
                      fieldId: "b4baqs",
                      fieldType: "text-input",
                      properties: {
                        name: "surname",
                        autocomplete: "no",
                        label: "Prenume",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|onlyLetters",
                        grid: {
                          alignItems: "center",
                          justifyContent: "center",
                          columns: 12
                        },
                        styles: {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "gofije",
                      fieldType: "text-input",
                      properties: {
                        name: "name",
                        autocomplete: "no",
                        label: "Nume",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|onlyLetters",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "h7kzf9",
                      fieldType: "text-input",
                      properties: {
                        name: "email",
                        label: "E-mail",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|email",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "vake42c",
                      fieldType: "text-input",
                      properties: {
                        name: "mobile",
                        label: "Numar de telefon",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "required|phoneNumber",
                        grid: {
                          columns: 12
                        },
                        autocomplete: "nope",
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "h7kzf8",
                      fieldType: "text-input",
                      properties: {
                        name: "address",
                        label: "Adresa",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "requiredAdress|adress",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        }
                      }
                    },
                    {
                      fieldId: "ko3h1sz",
                      fieldType: "paragraph",
                      properties: {
                        text: "*strada, numar, bloc, scara, apartament",
                        grid: {
                          columns: "12",
                          marginTop: "20px;",
                          marginBottom: "20px"
                        },
                        classes: ["disclaimer"],
                        styles: {
                          color: "#2E2E2E !important"
                        }
                      }
                    }
                  ],
                  extraFields: [
                    {
                      fieldId: "bdsb632",
                      fieldType: "select-input-county",
                      properties: {
                        name: "judet",
                        label: "Judet",
                        placeholder: "Judet",
                        text: "",
                        color: "#2E2E2E",
                        validation: "requiredJudet",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "30px",
                          "border-color": "#1A1A18"
                        },
                        autocomplete: "nope"
                      }
                    },
                    {
                      fieldId: "bask257",
                      fieldType: "select-input-city",
                      properties: {
                        name: "localitate",
                        label: "Localitate",
                        placeholder: "Localitate",
                        text: "",
                        color: "#2E2E2E",
                        validation: "requiredLocal",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        autocomplete: "nope"
                      }
                    },
                    {
                      fieldId: "acasg235",
                      fieldType: "text-input",
                      properties: {
                        name: "postal",
                        label: "Cod postal",
                        placeholder: "",
                        text: "",
                        color: "#2E2E2E",
                        validation: "integer|length:6",
                        grid: {
                          columns: 12
                        },
                        styles: {
                          "margin-top": "50px",
                          "border-color": "#1A1A18"
                        },
                        autocomplete: "nope",
                        disablePaste: true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: "yh453gg4",
            grid: {
              columns: 12,
              display: "flex",
              alignItems: "center",
              position: "relative",
              paddingTop: "60px",
              paddingBottom: "130px"
            },
            container: true,
            styles: {
              "justify-content": "center"
            },
            fields: [
              {
                fieldType: "button-component",
                fieldId: "16tzm2",
                properties: {
                  grid: {
                    columns: "0",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  text: "TRIMITE",
                  disabled: false,
                  addClass: "btn-dark-red-gradient2",
                  action: {
                    fn: "sendForm",
                    params: "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      {
        // Winner thank you
        pageName: "WomenDay2026/WinnerThankYou",
        pageId: 99830,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "thank-you-winner",
                fieldId: "gjd10",
                properties: {
                  campaign: "WomenDay2026",
                  campaignName: " Campania Nationala Women's day",
                  haveActivator: false,
                  textColor: "#141414"
                }
              }
            ]
          }
        ]
      },
      {
        // Receipt reupload
        pageName: "WomenDay2026/receipt-reupload",
        isPublic: true,
        pageId: 32,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            headerWrap: true,
            sectionId: "fu30zq",
            fields: [
              {
                fieldType: "query-string-to-state",
                fieldId: "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              { // 72 Hours check
                fieldType: 'checkReceiptToken',
                fieldID: 'dksnfsdkjf',
                properties: {
                  grid: { columns: 12 }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "<h1>Incarca bonul fiscal/factura</h1>",
                  styles: {
                    color: "#141414"
                  }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "La acest pas, te rugam sa incarci dovada achizitionarii produselor participante Palmolive",
                  grid: {
                    marginTop: "15px",
                    marginBottom: "30px"
                  },
                  styles: {
                    "font-weight": "500;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "20px;",
                    color: "#2E2E2E;"
                  }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "basg325",
                properties: {
                  text: "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al bonului fiscal/facturii",
                  grid: {
                    marginBottom: "40px"
                  },
                  styles: {
                    "font-weight": "400;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "14px;",
                    "line-height": "20px;",
                    color: "#474747;"
                  }
                }
              }
            ]
          },
          {
            sectionId: "dyx8uv",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "empty-bucket",
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: "center",
                    maxWidth: "1230px"
                  },
                  fields: [
                    {
                      fieldType: "receipt-processor",
                      fieldId: "klvakj",
                      properties: {
                        texts: {
                          choose: "Selecteaza un fisier",
                          receiptUpload:
                            '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat:
                            "Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.",
                          fileSizeLimit:
                            "Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB."
                        },
                        colorSchema: "#024491",
                        fileUploadColor: "rgba(0, 0, 0, 0.5)",
                        borderColor: "#024491",
                        textColor: "#141414",
                        buttonClass: "btn-blue-gradient",
                        grid: {
                          columns: 5,
                          alignItems: "center",
                          justifyContent: "center"
                        },
                        successAction: {
                          fn: "goToPage",
                          params: "WomenDay2026/Multumesc"
                        },
                        campaignId: "womenday-ro-2026",
                        phrases: [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        cornerDetectionPhrases: [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        eraseColor: "#ffffff",
                        eraseSize: 12,
                        cropColor: "#F27B26",
                        cropBackground: "rgba(0,0,0,0.6)",
                        cropTitle: "Decupeaza",
                        eraseTitle: "Acopera",
                        dragTitle: "Deplaseaza imaginea",
                        zoomInTitle: "Mareste",
                        zoomOutTitle: "Micsoreaza",
                        selectImageTitle: "Select an Image",
                        selectAnotherTitle: "Select Another",
                        controlsBackground: "#024491",
                        backgroundColorBtn: "black",
                        reUpload: true,
                        tokenName: "token"
                      }
                    },
                    {
                      fieldType: "empty-bucket",
                      properties: {
                        grid: {
                          columns: 7
                        },
                        fields: [
                          {
                            fieldType: "receipt-information",
                            fieldId: "5mq1p6",
                            properties: {
                              grid: {
                                alignItems: "center",
                                justifyContent: "center",
                                columns: "12"
                              },
                              styles: {
                                "text-align": "left"
                              },
                              color: "#024491",
                              textColor: "#141414",
                              descriptionTextColor: "#2E2E2E",
                              descriptionText:
                                "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              receiptImage: "receipt24",
                              steps: [
                                {
                                  text: "Nume magazin",
                                  label: "A"
                                },
                                {
                                  text: "Produsele participante la promotie si pretul lor",
                                  label: "B"
                                },
                                {
                                  text: "Suma totala a bonului/facturii in LEI/RON",
                                  label: "C"
                                },
                                {
                                  text: "Nr bonului fiscal/facturii",
                                  label: "D"
                                },
                                {
                                  text: "Data si ora de pe bonul fiscal sau factura",
                                  label: "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: "bsbsd35",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "receipt-image-information"
              }
            ]
          },
          {
            sectionId: "hmgwhl",
            grid: {
              columns: 12,
              display: "flex",
              alignItems: "center",
              position: "relative",
              paddingTop: "60px",
              paddingBottom: "40px"
            },
            container: true,
            styles: {
              "justify-content": "center"
            },
            fields: [
              {
                fieldType: "button-component",
                fieldId: "16tzm2",
                properties: {
                  grid: {
                    columns: "0",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  text: "Trimite",
                  addClass: "btn-dark-red-gradient2",
                  shouldCheckCrop: true,
                  requires: ["klvakj"],
                  action: {
                    fn: "sendReceipt",
                    params: ""
                  }
                }
              }
            ]
          }
        ]
      },
      {
        // Product reupload
        pageName: "WomenDay2026/product-reupload",
        isPublic: true,
        pageId: 1282452,
        sections: [
          {
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            headerWrap: true,
            sectionId: "fu30zq",
            fields: [
              {
                fieldType: "query-string-to-state",
                fieldId: "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              { // 72 Hours check
                fieldType: 'checkReceiptToken',
                fieldID: 'dksnfsdkjf',
                properties: {
                  grid: { columns: 12 }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "uwxo2o",
                properties: {
                  text: "<h1>Incarca o poza a produsului</h1>",
                  styles: {
                    color: "#141414"
                  }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "basv352",
                properties: {
                  text: "Incarca o poza cu produsele participante in campanie",
                  grid: {
                    marginTop: "15px",
                    marginBottom: "30px"
                  },
                  styles: {
                    "font-weight": "500;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "20px;",
                    color: "#2E2E2E;"
                  }
                }
              },
              {
                fieldType: "paragraph",
                fieldId: "basg325",
                properties: {
                  text: "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  grid: {
                    marginBottom: "40px"
                  },
                  styles: {
                    "font-weight": "400;",
                    "font-family": "Plus Jakarta Sans;",
                    "font-size": "14px;",
                    "line-height": "20px;",
                    color: "#474747;"
                  }
                }
              }
            ]
          },
          {
            sectionId: "dyx8uv",
            grid: {
              columns: 12,
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "empty-bucket",
                properties: {
                  grid: {
                    columns: 0,
                    justifyContent: "center",
                    maxWidth: "1230px"
                  },
                  fields: [
                    {
                      fieldType: "product-upload",
                      fieldId: "ase123v",
                      properties: {
                        texts: {
                          choose: "Selecteaza un fisier",
                          receiptUpload:
                            '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat:
                            "Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.",
                          fileSizeLimit:
                            "Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB."
                        },
                        colorSchema: "#024491",
                        borderColor: "#024491",
                        buttonClass: "btn-blue-gradient",
                        grid: {
                          columns: 5,
                          alignItems: "center",
                          justifyContent: "center"
                        },
                        endpoint: "/uploadProductPhoto",
                        successAction: {
                          fn: "goToPage",
                          params: "WomenDay2026/Multumesc"
                        },
                        phrases: [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        cornerDetectionPhrases: [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        reUpload: true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            sectionId: "hmgwhl",
            grid: {
              columns: 12,
              display: "flex",
              alignItems: "center",
              position: "relative",
              marginTop: "60px",
              marginBottom: "30px"
            },
            container: true,
            styles: {
              "justify-content": "center"
            },
            fields: [
              {
                fieldType: "button-component",
                fieldId: "16tzm2",
                properties: {
                  grid: {
                    columns: "0",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  text: "Trimite",
                  addClass: "btn-dark-red-gradient2",
                  shouldCheckCrop: false,
                  requires: ["ase123v"],
                  action: {
                    fn: "sendProductPhotos",
                    params: ""
                  }
                }
              }
            ]
          }
        ]
      },
      {
        // Thank you after reupload
        pageName: "WomenDay2026/Multumesc",
        pageId: 99801,
        noContainer: true,
        sections: [
          {
            grid: {
              alignItems: "center",
              justifyContent: "center"
            },
            container: true,
            fields: [
              {
                fieldType: "thank-you",
                fieldId: "gjd10",
                properties: {
                  campaign: "WomenDay2026",
                  campaignName: " Campania Nationala Women's day",
                  haveActivator: false,
                  borderColor: "#27A6DE",
                  textColor: "#141414",
                  referenceColor: "#1A99D1"
                }
              }
            ]
          }
        ]
      },
      { // Error page
        pageName: 'WomenDay2026/error-page',
        pageId: 10424,
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: 'center',
              justifyContent: 'center',
              columns: 12
            },
            container: true,
            fields: [
              {
                fieldType: 'error-page',
                fieldId: 'gjd10',
                properties: {
                  grid: {
                    columns: '12'
                  },
                  showLottie: true,
                  buttonClass: 'btn-mint-green',
                  LottieUrl: '/assets/Lottie/error-Lottie-gray-bear-green-boat.txt'
                }
              }
            ]
          }
        ]
      },
      {
        // Faq
        pageName: "WomenDay2026/IntrebariFrecvente",
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: "center",
              justifyContent: "center",
              columns: 12,
              marginBottom: "50px"
            },
            fields: [
              {
                fieldType: "pdf-viewer",
                fieldId: "vabd69",
                properties: {
                  grid: {
                    alignItems: "center",
                    justifyContent: "center",
                    columns: "12"
                  },
                  link: "https://jolt-assets.s3.eu-central-1.amazonaws.com/template/promocolgatepalmolive-ro/WomenDay2026/faq.pdf"
                }
              }
            ]
          }
        ]
      },
      {
        // Castigatori
        pageName: "WomenDay2026/castigatori",
        isPublic: true,
        sections: [
          {
            grid: {
              alignItems: "center",
              justifyContent: "center",
              columns: 12,
              marginBottom: "50px"
            },
            fields: [
              {
                fieldType: "text-list",
                fieldId: "a6prst",
                properties: {
                  colorSchema: "#002923",
                  title: "Campania Nationala Women's day",
                  ordered: false,
                  items: [
                    {
                      title: `Voucher de vacanta, în valoare de 20.000 RON (TVA inclus)* - 1 castigator`,
                      text: `
                      <ul>
                        <li>Rebreanu Lucia - C411FKX6DK</li>
                      </ul>`
                    },
                    {
                      title: `Voucher pentru achiziția bijuteriilor, în valoare de 15.000 RON (TVA inclus)* - 1 castigator`,
                      text: `
                      <ul>
                        <li>Damian Corneliu - HXRA8TKBZ6</li>
                      </ul>`
                    },
                    {
                      title: `Espressor automat - 3 castigatori`,
                      text: `
                      <ul>
                        <li>Fodorean Ieremia - XWKITJMQZ3</li>
                        <li>Stoica Doinita - ARAC5HPA53</li>
                        <li>Radu Iulian Traian - 7ZPT4ENPEN</li>
                      </ul>`
                    },
                    {
                      title: `Uscător de păr - 3 castigatori`,
                      text: `
                      <ul>
                        <li>Stan Anton - 1YQ78K55TR</li>
                        <li>Stan Profira - HLZUB8S954</li>
                        <li>Popescu Beatrice - TA5964LL14</li>
                      </ul>`
                    },
                    {
                      title: `Data publicarii: 25.05.2026`,
                      text: ``
                    }
                  ],
                  grid: {
                    alignItems: "center",
                    justifyContent: "center",
                    columns: "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    header: {
      fieldType: "navbar",
      fieldId: "cbx34t",
      properties: {
        dataLayer: {
          GTM: {
            Sitelocale: "ro-ro",
            SiteTouchpoint: "",
            SiteCountry: "RO",
            SiteBrand: "",
            SiteLanguage: "RO",
            SitePlatform: "",
            SiteEnvironment: "Prod",
            SiteHost: "CTL",
            SiteTechnicalAgency: "Justsnap",
            SiteStatus: "Live",
            GoogleAnalyticsLocal: "UA-15274544-47",
            GoogleAnalyticsBrand: "",
            GoogleAnalyticsSiteSpeedSampleRate: "high",
            GoogleAnalyticsAllowLinker: "true",
            GoogleAnalyticsLinkerDomains: "",
            GoogleAnalyticsEnableOptimizely: "false",
            GoogleAnalyticsConsentRequired: "true",
            GoogleAnalyticsOptimizeContainerID: "",
            GoogleAnalyticsReportingView: "",
            GoogleReCaptcha: "true",
            SiteLocalContainer: "",
            FacebookRemarketingID: "270266680523196",
            ConsentOverlay: "OneTrust",
            ConsentOverlayID:
              "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            SitePrivacyProtection: "GDPR"
          },
          GTM_CODE: "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        title: "",
        color: "#FAF6EE",
        grid: {
          columns: 12
        },
        logo: {
          imageSource: "/assets/logo.svg",
          width: 345,
          alternateText: "Brand Logo",
          paddingTop: "30px"
        },
        fields: [
          // {
          //   "fieldId": "bsdb35",
          //   "fieldType": "anchor",
          //   "properties": {
          //     "text": "Castigatori",
          //     "url": "/WomenDay2026/castigatori",
          //     "target": "_blank",
          //     "cssClass": "nav-link",
          //     "styles": {
          //       "color": "#050E23",
          //       "fontSize": "18px",
          //       "fontWeight": "400"
          //     }
          //   }
          // },
          {
            fieldId: "ikz8vc",
            fieldType: "anchor",
            properties: {
              text: "Regulament",
              url: "/files/WomenDay2026Regulament.pdf",
              target: "_blank",
              cssClass: "nav-link",
              styles: {
                color: "#050E23",
                fontSize: "18px",
                fontWeight: "400"
              }
            }
          },
          {
            fieldId: "slnmdk",
            fieldType: "anchor",
            properties: {
              text: "Intrebari frecvente",
              url: "/WomenDay2026/IntrebariFrecvente",
              target: "_blank",
              cssClass: "nav-link",
              styles: {
                color: "#050E23",
                fontSize: "18px",
                fontWeight: "400"
              }
            }
          }
        ],
        showLine: false,
        meta: [
          { name: "title", content: "Palmolive" },
          {
            name: "description",
            content: `Palmolive`
          },
          {
            name: "keywords",
            content: `Palmolive`
          }
        ]
      }
    },
    footer: {
      fieldType: "footer-component",
      fieldId: "4tfbzz",
      properties: {
        links: [{ name: "", link: "" }],
        supportLinks: [
          {
            name: "Confidentialitate",
            link: "https://www.jnjconsumer.ro/politica-confidentialitate"
          }
        ],
        styles: {
          color: "#000"
        },
        fields: [
          {
            fieldId: "ikz8vc1",
            fieldType: "anchor",
            properties: {
              text: "Termeni si conditii",
              url: "/files/WomenDay2026Regulament.pdf",
              target: "_blank",
              styles: {
                color: "#40454A"
              }
            }
          },
          {
            fieldId: "slnmdk2",
            fieldType: "anchor",
            properties: {
              text: " Politica de confidentialitate",
              url: "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
              target: "_blank",
              styles: {
                color: "#40454A"
              }
            }
          }
        ]
      }
    },
    campaignId: "womenday-ro-2026",
    url: "WomenDay2026",
    name: "womenday-ro-2026"
  },
  pageBuilder: {
    selectedField: {
      sectionId: "",
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: "error",
    message: "An error has occurred",
    isActive: false
  },
  customerToken: "",
  receiptToken: "",
  receiptImage: "",
  campaignId: "womenday-ro-2026",
  formData: new FormData(),
  campaignStartDate: "2026-02-14",
  campaignEndDate: "2026-04-13",
  showNavLinks: false,
  excludedPages: ["home"],
  cities: []
};
